import React from 'react';
import { Toaster } from 'react-hot-toast';
import './App.css';
import Oneliner from './components/Oneliner';
import NowPlaying from './components/NowPlaying';
import AuthLinks from './components/AuthLinks';
import MainRouter from './components/MainRouter';
import Banner from './components/Banner';
import { AuthProvider } from './hooks/useAuth';

function App() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" />
      <div className="app-layout">
        {/* Left sidebar - full height */}
        <div className="sidebar-left">
          <Oneliner />
        </div>

        {/* Main content area */}
        <div className="main-content">
          <div className="relative w-full overflow-hidden">
            <Banner />
          </div>
          <MainRouter />
        </div>

        {/* Right sidebar - full height */}
        <div className="sidebar-right">
          <NowPlaying />
          <AuthLinks />
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;
